import { render } from "./credit-notes.vue?vue&type=template&id=3db6688e"
import script from "./credit-notes.vue?vue&type=script&lang=js"
export * from "./credit-notes.vue?vue&type=script&lang=js"

import "./credit-notes.vue?vue&type=style&index=0&id=3db6688e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__